<template>
    <BasePanel
        headline='lang_AZ_COMMUNICATION_LIST'
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-container fluid>
                <template>              
                    <v-data-table
                        :headers="headers"
                        :items="commsList"
                        :items-per-page="1000"
                        hide-default-footer
                        :header-props="{ sortIcon: '' }"
                        :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                        class="noMinWidth"
                    >
                        <!-- TOP SLOT -->
                        <template v-slot:top>
                            <v-row class="pb-3">
                                <v-spacer></v-spacer>
                                <v-col cols="3">
                                    <BaseButton 
                                        @click="addNewRow"
                                        :disabled="isNewEntity"
                                        label="lang_GENERAL_BUTTON_ADD_ROW"
                                        block
                                        :alvqa="alvqa + '-button-add-row'"
                                    />
                                </v-col>
                            </v-row>
                        </template>
                        <!-- Headers -->
                        <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                            <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                        </template>
                        <!-- Items -->
                        <template v-slot:item="{ item }">
                            <tr>
                                <td>{{ item.commDate !== null && item.commDate !== '0000-00-00' ? $d(new Date(item.commDate), 'alvDateFormat') : '' }}</td>
                                <td>{{ $t(getCommunicationType(item.commType)) }}</td>
                                <td class="ellipsis">
                                    <BaseTooltip>
                                        <template v-slot:text>{{ item.commNotes }}</template>
                                        <template v-slot:content>
                                            <span :alvqa="alvqa + 'list-row' + item.id + '-text-display-communication-note'">{{ item.commNotes }}</span>
                                        </template>
                                    </BaseTooltip>
                                </td>
                                <td>{{ item.recontactDate !== null && item.recontactDate !== '0000-00-00' ? $d(new Date(item.recontactDate), 'alvDateFormat') : '' }}</td>
                                <td class="ellipsis">
                                    <BaseTooltip>
                                        <template v-slot:text>{{ item.recontactHook }}</template>
                                        <template v-slot:content>
                                            <span :alvqa="alvqa + 'list-row' + item.id + '-text-display-recontact-note'">{{ item.recontactHook }}</span>
                                        </template>
                                    </BaseTooltip>
                                </td>
                                <td>{{ getYesOrNo(item.status) }}</td>

                                <td>
                                    <BaseIcon   
                                        :alvqa="alvqa + '-list-row-icon-inline-edit'"
                                        icon="edit" 
                                        tooltipText="lang_GENERAL_CAPTION_ICON_EDIT"   
                                        @click.stop="editRow(item)"
                                    />
                                </td>
                                <td>
                                    <BaseIcon 
                                        @click="deleteRow(item)"
                                        icon="delete"
                                        tooltipText="lang_GENERIC_CAPTION_DELETE"
                                        :alvqa="alvqa + 'list-row-icon-delete'"
                                    />
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
            </template>
            </v-container>
        </template>
    </BasePanel>
</template>

<script>

import BaseListPage from '@/components/_base/BaseListPage'
import BasePanel from '@/components/_base/BasePanel'
import BaseTooltip from '@/components/_base/BaseTooltip'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseIcon from "@/components/_buttons/BaseIcon"

import { DropdownGenericYesNo, DropdownAzPersonsCommunicationsType } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "CommunicationListPanel",
    components: {
        BasePanel,
        BaseListPage,
        BaseTooltip,
        BaseButton,
        BaseIcon    
    },
    data() {
        return {
            alvqa: "az-persons-edit-form-panel-communications",
        }
    },
    computed: {
        headers() {
            return [
            {
                    text: this.$t('lang_DATUM'), 
                    value: 'commDate',
                    align: 'left', 
                    sortable: true, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_AZ_COMMUNICATION_LIST_CHANNEL'), 
                    value: 'commType',
                    align: 'left', 
                    sortable: false, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_NOTES'), 
                    value: 'commNotes',
                    align: 'left', 
                    sortable: false, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_AZ_COMMUNICATION_LIST_RECONTACT'), 
                    value: 'commRecontactDate',
                    align: 'left', 
                    sortable: false,  
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_AZ_COMMUNICATION_LIST_HOOK'), 
                    value: 'commRecontactHook',
                    align: 'left', 
                    sortable: true,  
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTIONS_DONE'), 
                    value: 'commStatus',
                    align: 'left', 
                    sortable: false,  
                    class: 'text-no-wrap'
                },
                {
                    text: "",
                    sortable: false,
                    value: "edit",
                    width: "60px",
                },
                {
                    text: "",
                    sortable: false,
                    value: "delete",
                    width: "60px",
                }
            ]
        },
        commsList(){
            return this.$store.getters.getAzPersonsCommunication
        },  
        isNewEntity() {
            return this.$route.params.alvId === 'new'
        },
    },
    methods: {
        addNewRow(){
            this.$store.commit('setShowAzPersonsCommunicationEditingDialog', true)
            let defaultValues = JSON.parse(JSON.stringify(this.$store.getters.getDefaultAzPersonsCommunication))
            this.$store.commit('setAzPersonsCommunicationEditingDialogDetails', defaultValues)
            this.$store.commit('setEditingDialogHeadline', this.$t('lang_GENERAL_CAPTION_NEW_ENTRY'))
        },
        editRow(item) {
            this.$store.commit('setSelectedAzPersonsCommunication', item.id)
            let detailsDeepCopy = JSON.parse(JSON.stringify(item))
            // set the copy in dialog details to edit
            this.$store.commit('setAzPersonsCommunicationEditingDialogDetails', detailsDeepCopy)
            this.$store.commit('setEditingDialogHeadline', this.$t("lang_GENERAL_CAPTION_EDITING_ENTRY")) // set headline
            this.$store.commit('setShowAzPersonsCommunicationEditingDialog', true) 
        },
        deleteRow(item){
            this.$store.commit('setSelectedAzPersonsCommunication', item)
            this.$store.commit('setDeletionDialogContext', 'SelectedAzPersonsCommunication')
            this.$store.commit('setShowDeletionDialog', true)
        },
        getCommunicationType(selection) {
            if (selection) {
                return DropdownAzPersonsCommunicationsType.find(obj => {
                return obj.value === selection
                }).text
            } else {
                return ''
            }
        },
        getYesOrNo(value) {
            if(value == null) value = "no"
            let match = DropdownGenericYesNo.find(element => {
                return element.value === value
            }).text

            return this.$t(match)
        } 
    },
    created(){
       
    },
    mounted(){

    }
}
</script>